import { createFileRoute } from "@tanstack/react-router";
import HeadManager from "../services/HeadManager";

export const Route = createFileRoute("/confirmation")({
  head: (ctx) => {
    return HeadManager.routerHead(ctx);
  },
  component: RouteComponent,
  staticData: {
    booking_engine: {
      show_booking: true,
    },
  },
});

function RouteComponent() {
  return <></>;
}
